module.exports = __webpack_public_path__ + "img/openbadge-info-1-eng.72a18cb6.png";